import { render, staticRenderFns } from "./AgreementCreateView.vue?vue&type=template&id=48a7fe23&"
import script from "./AgreementCreateView.vue?vue&type=script&lang=js&"
export * from "./AgreementCreateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports